import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css"; // We will verify this exists next
import { AuthProvider } from "./context/AuthContext";

console.log("MAIN: start");

console.log("MAIN: before render");

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
);
